import * as React from "react";
import type { SVGProps } from "react";
const SvgMarker01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2.817 21.6h5.01m-2.505-9.183V2.4h15.86l-2.504 5.009 2.505 5.008zm0 0v8.348"
    />
  </svg>
);
export default SvgMarker01;
